import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
export default function TA() {
    return (
    <>
        <div id="home">
            <h1>Current TAs:</h1>
            <p>Currently there is 1 TA.</p>
            <CardGroup>
                <Card>
                    <Card.Img variant="top" src="" />
                    <Card.Body>
                    <Card.Title>ta123</Card.Title>
                    <Card.Text>
                        Head TA
                    </Card.Text>
                        Email: ta123@gatech.edu
                    </Card.Body>
                    <Card.Footer>
                    <small className="text-muted">Last updated 3 mins ago</small>
                    </Card.Footer>
                </Card>
            </CardGroup>
        </div>
    </>
    )
}